export const manipulateEditCourse = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};
